module.exports = __webpack_public_path__ + "assets/awselb.d7fb483c.svg";